import "./UpcomingProjects.css";
import {
  MapPin,
  ArrowLeft,
  ChevronLeft,
  ChevronRight
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { projects } from "../../pages/upcomingproject";

const Projects = ({ limit }) => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const isSlider = Boolean(limit);
  const visibleProjects = isSlider ? projects.slice(0, limit) : projects;

  const slide = (direction) => {
    const container = sliderRef.current;
    if (!container) return;

    const scrollAmount = container.offsetWidth * 0.9;
    container.scrollLeft += direction * scrollAmount;
  };

  return (
    <section className="latest-projects">
      {/* HEADER */}
      <div className="projects-header">
        <div>
          <h2>{isSlider ? "Upcoming Projects" : "All Projects"}</h2>
          {/* <p>When extraordinary landmarks meet impeccable service</p> */}
        </div>

        {isSlider ? (
          <Link to="/upcoming-projects" className="see-all">
            See All Projects →
          </Link>
        ) : (
          <button className="back-btn3" onClick={() => navigate("/")}>
            <ArrowLeft size={16} />
            Back to Home
          </button>
        )}
      </div>

      {/* SLIDER WRAPPER */}
      <div className="projects-slider-wrapper">

        <div
          ref={sliderRef}
          className={`projects-container ${isSlider ? "slider" : "grid"}`}
        >
          {visibleProjects.map((item) => (
            <div
              key={item.slug}
              className="project-card"
              onClick={() => navigate(`/upprojects/${item.slug}`)}
            >
              <div className="project-image">
                <img src={item.image} alt={item.title} />

                        <span className="rera-badge-card11">
          RERA Approved 
        </span>
                {/* <span className="top-badge">{item.topTag}</span> */}
                <span className="image-tag">{item.imageTag}</span>
              </div>

              <div className="project-content">
                <h4>{item.title}</h4>

                <div className="location">
                  <MapPin size={14} />
                  {item.location}
                </div>

                <span className={`status ${item.statusType}`}>
                  {item.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* SLIDE BUTTONS BELOW */}
        {isSlider && (
          <div className="slider-controls">
            <button onClick={() => slide(-1)}>
              <ChevronLeft size={22} />
            </button>
            <button onClick={() => slide(1)}>
              <ChevronRight size={22} />
            </button>
          </div>
        )}

      </div>
    </section>
  );
};

export default Projects;
